module.exports = __webpack_public_path__ + "img/rings_II.be295b80.png";